import React, { ReactNode } from "react";
import { css, Theme, useTheme } from "@emotion/react";

type Props = {
    children: ReactNode,
    itemGroupBoxWidth: number,
    itemBoxWidth: number,
};

const ItemHeaderGroupContainer: React.FC<Props> = ({ children, itemGroupBoxWidth, itemBoxWidth }) => {
    const theme: Theme = useTheme();

    const style = css`
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-right: calc(${itemGroupBoxWidth - itemBoxWidth}px);

        ${theme.breakpoints.down('xs')} {
            margin-right: 0;
        }
    `;

    return (
        <div css={style}>
            {children}
        </div>
    );
};

export default ItemHeaderGroupContainer;